<template>
  <div class="userCenter_right" v-loading="loading">
    <div class="title_div">
      <span
        class="title_left"
        :style="dialogFormVisible ? 'color:#808080;' : 'color:#2d50a1'"
        >组织架构</span
      >
      <i class="el-icon-arrow-right" v-show="dialogFormVisible"></i>
      <span class="title_left" v-show="dialogFormVisible">{{
        organizationalTitle
      }}</span>
    </div>
    <div v-show="!dialogFormVisible">
      <div class="title_input">
        <div class="title_input_left">
          <!--<el-input v-model="serachParm" placeholder="请输入内容"></el-input>-->
          <!--<el-input
              placeholder="请输入部门名称"
              size="medium"
              v-model="searchValue">
            <i slot="suffix" class="el-input__icon el-icon-search" @click="getOrganizationDept"></i>
          </el-input>-->
          <!--<el-button icon="el-icon-search" @click="getApplication" circle></el-button>-->
        </div>
        <div class="title_input_right">
          <el-button
            type="success"
            style="padding: 5px;"
            @click="addOrganizational"
            icon="el-icon-circle-plus"
            circle
            title="添加"
          ></el-button>
          <el-button
            type="success"
            style="padding: 5px;"
            @click="downloadTemplate"
            icon="el-icon-download"
            circle
            title="下载模板"
          ></el-button>
          <el-upload
            action="/service-center/api/v1/organization/dept/batchUploadDept"
            :show-file-list="false"
            :headers="headers"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            :on-success="handleBannerSuccess"
            :before-upload="beforeBannerUpload"
            class="bannerImgClass"
            style="margin-left: 10px"
          >
            <el-button
              type="primary"
              style="padding: 5px;"
              icon="el-icon-link"
              circle
              title="导入"
            ></el-button>
          </el-upload>
          <!--           <el-button type="warning" style="padding: 5px;"  icon="el-icon-edit" circle></el-button>-->
          <!--<el-button type="danger" style="padding: 5px;" @click="deleteOrganizationalAll" icon="el-icon-delete"
                     circle title="删除"></el-button>-->
        </div>
      </div>
      <div class="tableContent" style="padding: 0 18px 20px;">
        <el-table
          ref="singleTable"
          :data="tableData"
          border
          @selection-change="handleSelectionChange"
          row-key="uuid"
          border
          default-expand-all
          :tree-props="{ children: 'children', hasChildren: false }"
          style="width: 100%"
        >
          <el-table-column
            type="selection"
            header-align="center"
            align="center"
            width="55"
          >
          </el-table-column>
          <el-table-column
            label="序号"
            type="index"
            header-align="center"
            align="center"
            width="55"
          >
          </el-table-column>
          <el-table-column
            property="name"
            label="部门名称"
            width="200"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            property="code"
            label="部门编码"
            width="200"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column show-overflow-tooltip width="100" label="是否启用">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.survival === 'ENABLE' ? 'success' : 'info'"
                disable-transitions
                >{{ scope.row.survival == "ENABLE" ? "启用" : "停用" }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            property="createDate"
            show-overflow-tooltip
            width="160"
            label="创建时间"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            header-align="center"
            align="center"
            width="129"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="editOrganizational(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="deleteOrganizational(scope.row.uuid)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!--          <div style="text-align: right;margin-top: 10px;">
                      <el-pagination
                          @size-change="handleSizeChange"
                          @current-change="handleCurrentChange"
                          :current-page="currentPage4"
                          :page-sizes="[5, 10, 20, 50]"
                          layout="total, sizes, prev, pager, next, jumper"
                          :total="total">
                      </el-pagination>
                  </div>-->
      </div>
    </div>
    <div v-show="dialogFormVisible" class="addApplication">
      <el-form
        :model="form"
        :rules="rules"
        ref="formRef"
        label-width="80px"
        label-position="left"
      >
        <el-input v-show="false" v-model="form.uuid"/>

        <el-form-item label="上级部门" prop="parentUuid">
          <el-cascader
            style="width: 300px;"
            v-model="form.parentUuid"
            :options="options"
            :props="{ checkStrictly: true }"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item label="部门名称" prop="name">
          <el-input
            v-model="form.name"
            style="width: 300px;"
            autocomplete="off"
            placeholder="请输入部门名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="survival">
          <el-radio-group v-model="form.survival">
            <el-radio label="ENABLE" value="ENABLE">启用</el-radio>
            <el-radio label="DISABLE" value="DISABLE">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="创建人">
          <div>
            {{ form.creator }}
          </div>
        </el-form-item>
        <el-form-item label="创建时间">
          <div>
            {{ form.createDate }}
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveOrganizationDept"
          >确 定</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  getOrganizationDeptTree,
  deleteOrganizationDept,
  saveOrganizationDept,
} from "../../../utils/interface";

export default {
  name: "index",
  data() {
    const validParent=(rule,value,callback)=>{
      if(value==""){
        callback();
      }
      if (this.form.parentUuid instanceof Array) {
        let parentUuid = this.form.parentUuid[this.form.parentUuid.length - 1];
        if (parentUuid == this.form.uuid) {
          callback("上级部门不能是自己");
          return;
        }
      }
      callback();
    }
    return {
      options: [],

      loading: false,
      searchValue: "",
      form: {
        name: "",
        code: "",
        survival: "ENABLE",
        parentUuid: "",
        createdDate: "",
      },
      rules: {
        parentUuid:[
          {validator:validParent}
        ],
        name: [
          { required: true, message: "请输入部门名称", trigger: "change" },
        ],
      },
      currentPage4: 1,
      total: 0,
      pageSize: 10,
      formLabelWidth: "120px",
      dialogFormVisible: false,
      organizationalTitle: "",
      tableData: [],
      multipleSelection: [],
      headers: {
        Authorization: "Bearer " + this.$cookies.get("api_access_token"),
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    downloadTemplate() {
      let a = document.createElement("a");
      a.href = "/static/dept.xlsx";
      a.download = "组织结构模板.xlsx";
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    init() {
      this.searchValue = "";
      this.currentPage4 = 1;
      this.getNewcurrent();
      this.getOrganizationDeptTree();
      this.getOrganizationDept();
    },
    getOrganizationDeptTree() {
      let param = {};
      getOrganizationDeptTree(param).then((response) => {
        this.options = response;
      });
    },

    getOrganizationDept() {
      let param = {
        name: this.searchValue,
        current: this.currentPage4,
        pageSize: this.pageSize,
      };
      getOrganizationDeptTree(param).then((response) => {
        this.tableData = response;
      });
    },

    // 批量删除
    deleteOrganizationalAll() {
      if (this.multipleSelection.length <= 0) {
        this.$message("未选中部门!");
      } else {
        this.$confirm("确定删除被选中的部门?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          })
          .catch(() => {});
      }
    },
    // 单个删除
    deleteOrganizational(uuid) {
      this.$confirm("确定删除该部门?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteOrganizationDept(uuid).then((resp) => {
            if (resp.success) {
              this.getOrganizationDept();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: resp.message,
              });
            }
          });
        })
        .catch(() => {});
    },
    // 新增组织
    addOrganizational() {
      this.$refs.formRef.resetFields();
      this.form.uuid = "";
      this.form.name = "";
      this.form.code = "";
      this.form.survival = "ENABLE";
      this.form.parentUuid = "";
      this.form.creator = this.$store.state.isUsermessage.name;
      this.form.createdDate = this.moment().format("YYYY-MM-DD");
      this.dialogFormVisible = true;
      this.organizationalTitle = "新增部门";
    },
    // 编辑组织
    editOrganizational(row) {
      this.organizationalTitle = "编辑部门";
      this.dialogFormVisible = true;
      this.form = { ...row };
      this.form.creator = this.$store.state.isUsermessage.name;
      // this.form.createdDate = this.form.createDate
    },
    saveOrganizationDept() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.dialogFormVisible = false;
          if (this.form.parentUuid instanceof Array) {
            this.form.parentUuid = this.form.parentUuid[
              this.form.parentUuid.length - 1
            ];
          }
          this.form.children = [];
          console.log("-------------------------");
          saveOrganizationDept(this.form).then((response) => {
            this.getOrganizationDeptTree();
            this.getOrganizationDept();
            this.$message({
              message: "保存成功",
              type: "success",
              customClass: "zZindex",
            });
          });
        } else {
          this.$message.error('请正确填写信息');
        }
      });

    },
    getNewcurrent() {
      if (!this.$store.state.isLogin) {
        this.$router.push({ name: "login", params: { uuid: uuid } });
        return;
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getOrganizationDept();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getOrganizationDept();
    },
    beforeBannerUpload(file) {
      this.loading = true;

      if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
        this.$message.warning("上传文件只能为excel文件，且为xlsx,xls格式!");
        this.loading = false;
        return false;
      }
    },
    handleBannerSuccess(res) {
      console.log("------------res-------------");
      console.log(res);
      this.loading = false;
      if (!res.success) {
        let message = res.message + "<br>";
        res.data.forEach((item) => {
          message += item + "<br>";
        });
        this.$message({
          dangerouslyUseHTMLString: true,
          message: message,
          type: "error",
        });
      } else {
        this.getOrganizationDept();
        this.getOrganizationDeptTree();
      }
    },
  },
};
</script>

<style scoped lang="less">
.addApplication {
  padding: 20px 50px;

  .dialog-footer {
    text-align: center;

    /deep/ .el-button--primary {
      background-color: #2d50a1;
      border-color: #2d50a1;

      &:hover {
        background: #66b1ff;
        border-color: #66b1ff;
      }
    }
  }
}

.tableContent {
  /deep/ .el-table .el-table__cell {
    padding: 5px 0;
  }
}

.zZindex {
  position: relative;
  z-index: 999;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.userCenter_right {
  width: 966px;
  background: #fff;

  h4 {
    color: #2d50a1;
    padding: 20px 18px;
    border-bottom: 2px solid #f9f9f9;
  }

  .title_div {
    padding: 20px 18px;
    border-bottom: 2px solid #f9f9f9;
  }

  .title_input {
    padding: 20px 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .title_input_left {
    width: 300px;

    .el-input__icon {
      cursor: pointer;

      &:hover {
        color: #2d50a1;
      }
    }
  }

  .title_input_right {
    display: flex;
  }

  .title_left {
    font-weight: bold;
    color: #2d50a1;
  }

  .title_right {
    float: right;
    margin-right: 30px;
  }

  .userCenter_right_box {
    padding: 30px 18px;

    .formItem {
      display: flex;
      margin-bottom: 30px;
      position: relative;

      .title {
        width: 150px;
        line-height: 40px;
        letter-spacing: 1px;
        color: #494a4c;
      }

      .inputClass {
        width: 70%;
      }
    }

    .buttonGroupClass {
      text-align: right;

      button {
        padding: 8px 12px;
        background-color: #2d50a1;
        border-color: #2d50a1;

        &:hover {
          background-color: #4a96f1;
          border-color: #4a96f1;
        }

        i {
          padding-right: 5px;
          font-size: 14px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/registeredLogin/organizationalStructure/index.vue